import { render, staticRenderFns } from "./VTemplates.vue?vue&type=template&id=289f077b&"
import script from "./VTemplates.vue?vue&type=script&lang=js&"
export * from "./VTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports